import { motion, useScroll, useTransform } from "motion/react";
import { useRef, useState, useEffect } from "react";
import styles from "./supportCommunity.module.scss";

export function SupportCommunity() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });
  const [coords0, setCoords0] = useState(`51° 2' 51.94" N`);
  const [coords1, setCoords1] = useState(`114° 4' 8.35" W`);

  const rollCoords = () => {
    const getRandomCoordinate = () => {
      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      function toDMS(deg, isLat) {
        const absolute = Math.abs(deg);
        const d = Math.floor(absolute);
        const mFloat = (absolute - d) * 60;
        const m = Math.floor(mFloat);
        const s = ((mFloat - m) * 60).toFixed(2);
        const dir = isLat ? (deg >= 0 ? "N" : "S") : deg >= 0 ? "E" : "W";
        return `${d}° ${m}' ${s}" ${dir}`;
      }

      const lat = randomInRange(41.7, 83.1);
      const lng = randomInRange(-141.0, -52.6);

      return `${toDMS(lat, true)}, ${toDMS(lng, false)}`;
    };

    const interval = setInterval(() => {
      const _coords = getRandomCoordinate().split(", ");
      setCoords0(_coords[0]);
      setTimeout(() => {setCoords1(_coords[1])}, 100)
    }, 150);

    setTimeout(() => {
      clearInterval(interval);
      setCoords0(`51° 2' 51.94" N`)
      setCoords1(`114° 4' 8.35" W`)
    }, 3000)
  }

  // Position transforms for social images
  const socialImage0Right = useTransform(
    scrollYProgress,
    [0, 0.5],
    ["0%", "-10%"],
  );
  const socialImage1Right = useTransform(
    scrollYProgress,
    [0, 0.5],
    ["0%", "-5%"],
  );
  const socialImage3Left = useTransform(
    scrollYProgress,
    [0, 0.5],
    ["0%", "-5%"],
  );
  const socialImage4Left = useTransform(
    scrollYProgress,
    [0, 0.5],
    ["0%", "-10%"],
  );

  // Create multiple copies for seamless scrolling
  const repeatedCoords = [...coords, ...coords, ...coords];

  return (
    <div className={styles.container} ref={containerRef}>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{
          type: "spring",
          duration: 0.8,
          delay: 0.2,
          ease: "easeOut",
        }}
        className={styles.sectionHeader}
      >
        Calgary <span>is dinos</span> territory
      </motion.h2>

      <section className={styles.imagesContainer}>
        {images.map((image, index) => {
          let style = {};
          let initial = { opacity: 0 };
          let whileInView = { opacity: 1 };

          if (index === 0) {
            style = { right: socialImage0Right };
            initial = { opacity: 0, x: 100 };
            whileInView = { opacity: 1, x: 0 };
          } else if (index === 1) {
            style = { right: socialImage1Right };
            initial = { opacity: 0, x: 80 };
            whileInView = { opacity: 1, x: 0 };
          } else if (index === 2) {
            initial = { opacity: 0, scale: 0.8 };
            whileInView = { opacity: 1, scale: 1 };
          } else if (index === 3) {
            style = { left: socialImage3Left };
            initial = { opacity: 0, x: -80 };
            whileInView = { opacity: 1, x: 0 };
          } else if (index === 4) {
            style = { left: socialImage4Left };
            initial = { opacity: 0, x: -100 };
            whileInView = { opacity: 1, x: 0 };
          }

          return (
            <>
              <motion.img
                key={`social-${index}`}
                id={`social-${index}`}
                alt={image.alt}
                src={image.src}
                className={[
                  styles.socialImage,
                  index === 2
                    ? styles.socialImageCenter
                    : styles[`socialImage${index}`],
                ].join(" ")}
                style={style}
                initial={initial}
                whileInView={whileInView}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  type: "spring",
                  duration: 0.8,
                  delay: index * 0.1,
                  ease: "easeOut",
                }}
                onViewportEnter={index === 2 ? rollCoords : undefined}
              />
              {index === 2 && (
                <motion.div 
                  className={styles.socialOverlay}
                  initial={{ opacity: 0, scale: 0.8, y: 20 }}
                  whileInView={{ opacity: 1, scale: .8, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{
                    type: "spring",
                    duration: 0.8,
                    delay: 0.3,
                    ease: "easeOut"
                  }}
                >
                  <section className={styles.overlayHeader}>
                    {/* <h3>HERE WE</h3>
                    <h3>ROAR</h3> */}
                    <img src="icons/header-text-red.png" alt="" className={styles.overlayHeaderTitle} />
                  </section>
                  <section className={styles.overlayCoorsContainer}>
                    <p>DINOS TERRITORY</p>
                    <div>
                      <p>{coords0}</p>
                      <p>{coords1}</p>
                    </div>
                  </section>
                  <section className={styles.overlayLogo}>
                    <img src="logos/dinos-mini-logo.png" alt="" />
                  </section>
                </motion.div>
              )}
            </>
          );
        })}
      </section>

      <section className={styles.coordsContainer}>
        <motion.div
          className={styles.tickerContent}
          animate={{
            x: [
              0,
              -(coords.length * 300), // Approximate width per item including spacing
            ],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: coords.length * 4, // Adjust speed based on number of items
              ease: "linear",
            },
          }}
        >
          {repeatedCoords.map((coord, index) => (
            <p key={`coord-${index}`}>
              <span>{coord.split("|")[0]}</span> {coord.split("|")[1]}
            </p>
          ))}
        </motion.div>
      </section>
      <p></p>
    </div>
  );
}

const coords = [
  "Auburn Bay|50.8906° N, 113.9642° W",
  "Inglewood|51.0450° N, 114.0330° W",
  "Mahogany|50.8896° N, 113.9342° W",
  "Bridgeland|51.0580° N, 114.0470° W",
  "Beltline|51.0416° N, 114.0719° W",
  "Kensington|51.0536° N, 114.0852° W",
  "Mission|51.0327° N, 114.0726° W",
  "Sunalta|51.0459° N, 114.0947° W",
  "Hillhurst|51.0552° N, 114.0897° W",
  "Ramsay|51.0386° N, 114.0325° W",
  "Altadore|51.0222° N, 114.1208° W",
  "Marda Loop|51.0242° N, 114.1227° W",
  "Varsity|51.0897° N, 114.1536° W",
  "Dalhousie|51.0967° N, 114.1586° W",
  "Brentwood|51.0892° N, 114.1378° W",
  "Acadia|50.9786° N, 114.0597° W",
  "Crescent Heights|51.0631° N, 114.0581° W",
  "Eau Claire|51.0522° N, 114.0708° W",
  "Forest Lawn|51.0397° N, 113.9631° W",
  "Seton|50.8647° N, 113.9742° W",
  "Saddleridge|51.1208° N, 113.9572° W",
  "Coventry Hills|51.1422° N, 114.0592° W",
  "Panorama Hills|51.1428° N, 114.1108° W",
  "Tuscany|51.1272° N, 114.2411° W",
  "Signal Hill|51.0458° N, 114.1817° W",
  "West Springs|51.0558° N, 114.2106° W",
  "Aspen Woods|51.0450° N, 114.2022° W",
  "Lake Bonavista|50.9567° N, 114.0592° W",
  "Willow Park|50.9731° N, 114.0622° W",
  "Parkdale|51.0622° N, 114.1461° W",
  "Auburn Bay|50.8906° N, 113.9642° W",
  "Inglewood|51.0450° N, 114.0330° W",
  "Mahogany|50.8896° N, 113.9342° W",
  "Bridgeland|51.0580° N, 114.0470° W",
  "Beltline|51.0416° N, 114.0719° W",
  "Kensington|51.0536° N, 114.0852° W",
  "Mission|51.0327° N, 114.0726° W",
  "Sunalta|51.0459° N, 114.0947° W",
  "Hillhurst|51.0552° N, 114.0897° W",
  "Ramsay|51.0386° N, 114.0325° W",
  "Altadore|51.0222° N, 114.1208° W",
  "Marda Loop|51.0242° N, 114.1227° W",
  "Varsity|51.0897° N, 114.1536° W",
  "Dalhousie|51.0967° N, 114.1586° W",
  "Brentwood|51.0892° N, 114.1378° W",
  "Acadia|50.9786° N, 114.0597° W",
  "Crescent Heights|51.0631° N, 114.0581° W",
  "Eau Claire|51.0522° N, 114.0708° W",
  "Forest Lawn|51.0397° N, 113.9631° W",
  "Seton|50.8647° N, 113.9742° W",
  "Saddleridge|51.1208° N, 113.9572° W",
  "Coventry Hills|51.1422° N, 114.0592° W",
  "Panorama Hills|51.1428° N, 114.1108° W",
  "Tuscany|51.1272° N, 114.2411° W",
  "Signal Hill|51.0458° N, 114.1817° W",
  "West Springs|51.0558° N, 114.2106° W",
  "Aspen Woods|51.0450° N, 114.2022° W",
  "Lake Bonavista|50.9567° N, 114.0592° W",
  "Willow Park|50.9731° N, 114.0622° W",
  "Parkdale|51.0622° N, 114.1461° W",
];

const images = [
  { alt: "", src: "social/social-1.png" },
  { alt: "", src: "social/social-2.png" },
  { alt: "", src: "social/social-3.png" },
  { alt: "", src: "social/social-4.png" },
  { alt: "", src: "social/social-5.png" },
];
